import { ObjetK, enumValue } from '@siclop/kstone-vue'
import { LeaveRequestStatus } from '../enums'

export class LeaveRequest extends ObjetK {
  employeeId: number = 0
  leaveTypeId: number = 0
  status: LeaveRequestStatus = LeaveRequestStatus.Draft
  startDate: string = ''
  endDate: string = ''
  startHalfDay: boolean = false
  endHalfDay: boolean = false
  totalDays: number = 0
  reason: string = ''
  reviewedByEmployeeId?: number
  reviewedAt?: string
  reviewComment?: string
  /** Seconde décision (sur-validation RH / direction). */
  secondReviewedByEmployeeId?: number
  secondReviewedAt?: string
  secondReviewComment?: string
  /** Annulation (action « Annuler ») : qui, quand, motif facultatif. */
  cancelledByEmployeeId?: number
  cancelledAt?: string
  cancellationComment?: string
  documentId?: number
  leaveTypeName?: string
  leaveTypeColor?: string
  employeeName?: string

  constructor(data?: Partial<LeaveRequest>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId ?? 0
      this.leaveTypeId = data.leaveTypeId ?? 0
      this.status = enumValue(LeaveRequestStatus, data.status, LeaveRequestStatus.Draft)
      this.startDate = data.startDate ?? ''
      this.endDate = data.endDate ?? ''
      this.startHalfDay = data.startHalfDay ?? false
      this.endHalfDay = data.endHalfDay ?? false
      this.totalDays = data.totalDays ?? 0
      this.reason = data.reason ?? ''
      this.reviewedByEmployeeId = data.reviewedByEmployeeId
      this.reviewedAt = data.reviewedAt
      this.reviewComment = data.reviewComment
      this.secondReviewedByEmployeeId = data.secondReviewedByEmployeeId
      this.secondReviewedAt = data.secondReviewedAt
      this.secondReviewComment = data.secondReviewComment
      this.cancelledByEmployeeId = data.cancelledByEmployeeId
      this.cancelledAt = data.cancelledAt
      this.cancellationComment = data.cancellationComment
      this.documentId = data.documentId
      this.leaveTypeName = data.leaveTypeName
      this.leaveTypeColor = data.leaveTypeColor
      this.employeeName = data.employeeName
    }
  }
}
